export class KafkaTopicPartition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "topic",
            "baseName": "topic",
            "type": "string",
            "format": ""
        },
        {
            "name": "partition",
            "baseName": "partition",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaTopicPartition.attributeTypeMap;
    }
    constructor() {
    }
}
